module.exports = __webpack_public_path__ + "img/trophy.58c018dc.gif";